import { useState } from 'react'
import { useAuth } from '@/stores/auth'
import { isAdminRole, isTeacherRole } from '@/utils/roles'
import ParishMessenger from '@/components/messaging/ParishMessenger'
import AutoEmailButtons from '@/components/messaging/AutoEmailButtons'
import RecurringMessageModal from '@/components/messaging/RecurringMessageModal'

/** Message Center (spec section 7): parish messenger + staff email/recurring tools. */
export default function MessageCenter() {
  const { user } = useAuth()
  const [showRecurring, setShowRecurring] = useState(false)
  const isStaff = isAdminRole(user?.role) || isTeacherRole(user?.role)

  return (
    <section className="mt-6" aria-label="Messages">
      <h2 className="text-lg font-semibold mb-2">Messages</h2>
      <p className="mb-3 text-xs text-gray-600 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
        🔒 Catechism Cloud messages are encrypted and reasonably secure, but can be read, if necessary, by Catechism Cloud.
      </p>
      <ParishMessenger />

      {isStaff && user && (
        <div className="mt-6 space-y-3">
          <AutoEmailButtons userRole={user.role} />
          {isAdminRole(user.role) && (
            <div className="flex items-center gap-2">
              <button onClick={() => setShowRecurring(true)} className="btn-primary focus-ring flex items-center gap-2">
                <span>📅</span>
                <span>Create Recurring Message</span>
              </button>
              <p className="text-xs text-gray-500">Schedule automatic messages to be sent on a recurring basis</p>
            </div>
          )}
          <RecurringMessageModal open={showRecurring} onClose={() => setShowRecurring(false)} onCreated={() => {}} />
        </div>
      )}
    </section>
  )
}
